var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-favorites sidebar__responsive__element"},[_c('Tournaments',{attrs:{"tournaments":_vm.sortedTournaments},on:{"removeClick":_vm.onRemoveTournamentClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf50ff2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/sportOffer/favourites/sidebar/FavouritesSidebarContainer.vue
// module id = 1914
// module chunks = 0